/**
 * Utilities for enriching analytics events with context.
 */

import { COMMON_PROPERTIES } from '../constants/event-properties.js';
import type { AnalyticsEvent } from '../types/events.js';
import { resolveAnalyticsContext } from './context-resolver.js';

/**
 * Enrich an analytics event with common context.
 *
 * This function adds common properties to the event, such as:
 * - User ID
 * - Environment
 * - Vendor
 * - Timestamp
 *
 * @param event The event to enrich
 * @returns The enriched event
 */
export function enrichWithContext(event: AnalyticsEvent): AnalyticsEvent {
  const timestamp = event.timestamp || Date.now();
  const properties = resolveAnalyticsContext(event.properties ?? {});

  return {
    ...event,
    timestamp,
    properties: {
      ...properties,
      // Ensure timestamp is included in properties
      [COMMON_PROPERTIES.TIMESTAMP]: timestamp
    }
  };
}
